export enum WeekDayMap {
  monday = 1,
  tuesday,
  wednesday,
  thursday,
  friday,
  saturday,
  sunday
}

export type WeekDay = keyof typeof WeekDayMap;
